export default {
  entitiesSummary: 'ENTITIES_SUMMARY',
  eventsSummary: 'EVENTS_SUMMARY',
  entityOverview: 'ENTITY_OVERVIEW',
  eventOverview: 'EVENT_OVERVIEW'
};